import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {useSelector} from "react-redux";
import ListSharpIcon from '@material-ui/icons/ListSharp';
import EventsSection from "./EventsSection";

function TabContainer({children, dir}) {
    return (
        <div dir={dir} style={{padding: 8 * 3}}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

const CIRTEvents = (props) => {
    const [value, setValue] = useState(0);
    const {customerInView} = useSelector(({customer}) => customer);

    const {theme} = props;

        return (
            <div className="w-100 animated fadeIn animation-duration-7">


                <AppBar position="sticky" color="default">
                    <Tabs
                        value={value}
                        onChange={(event, newValue) => setValue(newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="on"
                    >
                        <Tab icon={<ListSharpIcon/>} className="tab" label="All Events"/>
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={(event, newValue) => setValue(newValue)}
                >
                    <TabContainer dir={theme.direction}>

                    <EventsSection customerId={customerInView}/>
                </TabContainer>
                </SwipeableViews>
            </div>
        );

}

CIRTEvents.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(CIRTEvents);